import PDFWrapper, {
  DukeFooterLogo,
  NationallyRecognisedTrainingLogo,
  Row,
  SignatureSection,
} from '../PdfLayout';
import Table from './Table';
import StatementOfAttainmentProps from './types';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  subHeader: {
    textAlign: 'center',
    fontSize: 10,
    margin: '0 auto 10px auto',
    width: '360px',
    lineHeight: '14px',
    fontWeight: '400',
  },
  name: {
    textAlign: 'center',
    fontSize: 18,
    margin: '8px auto',
    width: '100%',
    fontFamily: 'Inter-SemiBold',
  },
  statementTitle: { textAlign: 'center', fontSize: 14, margin: '0 auto', width: '100%' },
  competencyContainer: {
    margin: '10px auto 0 auto',
    textAlign: 'left',
    lineHeight: '12px',
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  competencyRow: {
    display: 'flex',
    flexDirection: 'row',
    fontSize: 11,
    marginBottom: 2,
  },
  competencyCode: {
    width: '80px',
  },
  competencyTitle: {
    flex: 1,
  },
  competencyResult: {
    width: '80px',
  },
  section: { marginTop: '10px', textAlign: 'center' },
  rowContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: 20,
    textAlign: 'center',
    justifyContent: 'center',
  },
});

function StatementOfAttainment({ data }: { data: StatementOfAttainmentProps }): React.ReactElement {
  return (
    <PDFWrapper title="Statement of Attainment">
      <View
        style={{
          flexDirection: 'column',
          height: '100%',
        }}
      >
        <View
          style={{
            display: 'flex',
            flexGrow: 1,
          }}
        >
          <View>
            <Text style={styles.subHeader}>
              A statement of attainment is issued by a registered training organisation when an
              individual has completed one or more accredited units
            </Text>
            <Text style={styles.statementTitle}>This is a statement that</Text>
            <Text style={styles.name}>{data.name}</Text>
            <Text style={styles.statementTitle}>has attained</Text>
            <Table data={data.competencies} />
          </View>
        </View>

        <View
          style={{
            marginTop: 'auto',
            display: 'flex',
            flexDirection: 'column',
            gap: 12,
          }}
        >
          <View style={styles.section}>
            <Text style={styles.statementTitle}>These competencies form part of</Text>
            <Text
              style={{
                fontSize: 18,
                fontFamily: 'Inter-SemiBold',
                margin: '6px 0 0 0',
                lineHeight: '24px',
              }}
            >
              {data.course}
            </Text>
          </View>

          <View style={styles.rowContainer}>
            <Row
              label="Document ID"
              value={`${data.avetmissIdentifier}-${data.courseEnrolmentId}`}
            />
          </View>
        </View>

        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginTop: 10,
          }}
        >
          <View style={{ marginLeft: 16, marginTop: 12 }}>
            <View style={{ marginTop: 10 }}>
              <DukeFooterLogo />
            </View>
          </View>

          <View style={{ marginTop: 4 }}>
            <SignatureSection
              signatureDate={data.signatureDate}
              includeCEOSignature
              dateLabel="Date issued"
            />
          </View>

          <View style={{ marginRight: 16, marginTop: 14 }}>
            <NationallyRecognisedTrainingLogo />
          </View>
        </View>
      </View>
    </PDFWrapper>
  );
}

export default StatementOfAttainment;
